import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { AccountStorage } from "@services/account";
var accountStorage = new AccountStorage();
export default {
  data: function data() {
    return {
      code: null,
      showTime: false,
      time: 90,
      account: null
    };
  },
  props: ["isExistPhone", "phone"],
  methods: {
    back: function back() {
      this.$emit('back');
    },
    bindPhone: function bindPhone() {
      this.$emit('bindPhone');
    },
    modify: function modify() {
      var _this = this;
      if (!this.code) {
        //验证码
        this.$refs.code.focus();
        this.isCodeError = true;
        return;
      }
      var url = '/pjyy-deepexi-user-center/api/v1/common/forgetPwdThree';
      var params = {
        id: accountStorage.getCacheUserInfo().userId,
        loginSource: 'PC',
        verifyCode: this.code
      };
      this.$getHttpClient().post(url, params).then(function (res) {
        if (res.data.code == '200') {
          _this.$messageTip("重置密码成功", 'success');
          _this.$router.push({
            name: 'v2-login'
          });
        }
      });
    },
    getCode: function getCode() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var userInfo, url, res, that, timer;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              userInfo = accountStorage.getCacheUserInfo();
              _this2.account = userInfo.account;
              url = "/pjyy-deepexi-user-center/api/v1/common/forgetPwdTwo?account=".concat(_this2.account);
              _context.next = 5;
              return _this2.$getHttpClient().post(url);
            case 5:
              res = _context.sent;
              //let res = {data:{code:'200'}}
              if (res.data.code == '200') {
                _this2.showTime = true;
                //倒计时
                that = _this2;
                timer = setInterval(function () {
                  that.time--;
                  if (that.time == 0) {
                    clearInterval(timer);
                    that.time = 90;
                    _this2.showTime = false;
                  }
                }, 1000);
              } else {
                _this2.$messageTip(res.data.msg, 'error');
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};